import { Tag } from 'lucide-react';
import {Cellule} from "../../../../types/cellule";
import React, {useState} from "react";
import {useDisclosure} from "@mantine/hooks";
import ajax from "../../../../services/AxiosInterceptor";
import {Modal, TextInput} from "@mantine/core";
import {LoadingButton} from "../../../../components/loading_button/loading_button";

export function Modale_changer_nom({
                                       cellule,
                                       setCellule,
                                       forcer
                                   }: { cellule: Cellule, setCellule: React.Dispatch<Cellule | null>, forcer: boolean }) {
    const [opened, handlers] = useDisclosure(forcer);
    const [save_btn_loading, set_save_btn_loading] = useState(false);
    const [nom, set_nom] = useState(cellule.nom);

    // if (forcer) handlers.open();

    function handleEnregistrer() {
        set_save_btn_loading(true);
        ajax.put("/cellules/" + cellule.id, {...cellule, "nom": nom}).then(response => {
            setCellule({...cellule, "nom": nom});
            handlers.close();
            set_save_btn_loading(false);
        }).catch(error => {
        })

    }

    return (
        <>
            <button className={"sec"} onClick={handlers.open}><Tag/> Changer le nom</button>
            <Modal opened={opened} onClose={handlers.close} title="Changer le nom de la cellule">
                <div className={"form"}>
                    <TextInput type="text" value={nom} onChange={event => set_nom(event.target.value)} placeholder={"Nom de la cellule"}/>
                    <LoadingButton is_loading={save_btn_loading}
                                   onClick={handleEnregistrer}>Enregistrer</LoadingButton>
                </div>

            </Modal>
        </>

    )
}